import { render, staticRenderFns } from "./GrossMargin.vue?vue&type=template&id=08a33159"
import script from "./GrossMargin.vue?vue&type=script&lang=js"
export * from "./GrossMargin.vue?vue&type=script&lang=js"
import style0 from "./GrossMargin.vue?vue&type=style&index=0&id=08a33159&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports